import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'

function SCVideoComponent(props) {
  const { componentData, onVideoControlChange } = props
  const { Url } = componentData
  const video = {
    Url: Url
  }
  const [playing, setPlaying] = useState(false)

  useEffect(() => {
    if (onVideoControlChange) {
      onVideoControlChange(playing)
    }
  }, [playing])

  //   useEffect(() => {
  //     if (isSeqPlay || feedPlay) {
  //       setPlaying(false)
  //     }
  //   }, [isSeqPlay, feedPlay])

  return (
    <div className='sc-video-cont'>
      <ReactPlayer
        url={video.Url}
        width='100%'
        height='100%'
        playing={playing}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
        controls={true}
      />
    </div>
  )
}
export default SCVideoComponent
